import BaseButton from "../BaseButton";
import { BaseSButtonStyle } from "../../../types/Interface";


const buttonStyle: BaseSButtonStyle = {
  width: 200,
  height: 40,
  defaultColor: 0x21D4FE,
  hoverColor: 0x10C3F0,
  pressedColor: 0x21D4FE,
  borderColor:0x10C3F0,
  titleColor: 0x0195b8,
  titleFontSize: 20,
  wordWrapWidth: 200,
  borderRadius: 10
}


export default class PlayAnimationButton extends BaseButton {
  constructor(handleFunc: () => void) {
    super("Play Animation", buttonStyle, handleFunc)
  }
}